import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { RuleSmsTemplateApprovedWithAutosendActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function RuleSmsTemplateApprovedWithAutosend({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as RuleSmsTemplateApprovedWithAutosendActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》短信发送成功</ItemWrapper>
}
